<template>
  <el-container id="resvSetSon">
    <el-header style="height:40px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;align-items:center;height:100%">
        <i @click="onBack" class="el-icon-arrow-left" style="font-size:22px;"></i>
        <span style="font-size:22px;font-weight:bold;margin:0 10px;">{{ h_text }}</span>
      </div>
    </el-header>
    <el-container class="resv_main">
      <el-main style="background: #FFFFFF;">
        <div style="display:flex;align-items:center">
          <p style="font-size:20px;margin-left:20px;font-weight:bold;height:20px;line-height:20px">{{ name }}</p>
          <el-switch style="margin-left: auto"
                     v-model="isAppointing">
          </el-switch>
          <p style="margin-top:0;margin-bottom:0;margin-left:10px;margin-right:10px;">启动该区域预约</p>
        </div>
        <el-divider></el-divider>
        <p style="font-size:18px;font-weight:bold;margin:10px 10px 0 20px;">权限设置</p>
        <div style="display:flex ;margin-top:10px;padding-left:20px">
          <div style="width: 50%;display: flex;align-items: center">
            <el-switch
                v-model="onlyOwer">
            </el-switch>
            <p style="margin: 0 10px;">仅限业主预约</p>
          </div>
          <div style="width: 50%;display: flex;align-items: center">
            <el-switch
                v-model="needApproval">
            </el-switch>
            <p style="margin: 0 10px;">是否需要审批</p>
          </div>
        </div>
        <div style="display:flex ;margin-top:10px;padding-left:20px">
          <div style="width: 50%;display: flex;align-items: start">
            <el-switch
                v-model="isAttendNum">
            </el-switch>
            <div style="display: flex;flex-flow: column">
              <p style="margin:0 10px">预约是否需要填写人数</p>
              <div style="display:flex;align-items:center;margin-left:10px">
                <p style="margin-top: 6px;margin-bottom: 6px">预约最多填写人数</p>
                <el-input-number v-model="maxAttendNum" :step="1" style="width:200px;margin-left:5px"></el-input-number>
              </div>
            </div>
          </div>
          <div style="width: 50%;display: flex;align-items: center">
            <el-switch
                v-model="isCare">
            </el-switch>
            <p style="margin:0 10px">是否需要填写同行人关怀</p>
          </div>
        </div>
        <div style="display:flex ;margin-top:10px;padding-left:20px;margin-bottom:10px">
          <el-switch
              v-model="needService">
          </el-switch>
          <p style="margin:0 10px">是否需要服务内容</p>
        </div>
        <el-divider></el-divider>
        <p style="font-size:18px;font-weight:bold;margin:10px 10px 0 20px;">空间开放设置</p>
        <div style="display:flex ; margin-top:0px;padding-left:20px">
          <div style="width:30%">
            <p style="margin-top:6px;margin-bottom:6px">开放时间</p>
            <div style="display:flex;">
              <el-time-select
                  placeholder="起始时间"
                  style="width:49%"
                  v-model="startTime"
                  :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '24:00'
                }">
              </el-time-select>
              <p style="margin-top:6px;margin-left:6px;margin-right:6px"> 至 </p>
              <el-time-select
                  placeholder="结束时间"
                  style="width:49%"
                  v-model="endTime"
                  :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '24:00',
                  minTime: startTime
                }">
              </el-time-select>
            </div>
          </div>
          <div style="width:30%;margin-left:1%">
            <p style="margin-top: 6px;margin-bottom: 6px">每次时长(分钟)</p>
            <el-input-number v-model="timeGap" :step="1" style="width: 100%"></el-input-number>
          </div>
          <div style="width:30%;margin-left:1%">
            <p style="margin-top: 6px;margin-bottom: 6px">提前开门时间(分钟)</p>
            <el-input-number v-model="earlyTime" :step="1" style="width: 100%"></el-input-number>
          </div>
        </div>
        <div style="display:flex ; margin-top: 10px;padding-left:20px">
          <div style="width:30%;">
            <p style="margin-top: 6px;margin-bottom: 6px">清洁时长(分钟)</p>
            <el-input-number v-model="cleanTime" :step="1" style="width: 100%"></el-input-number>
          </div>
          <div style="width:30%;margin-left:1%">
            <p style="margin-top:6px;margin-bottom:6px">最远可预约天数</p>
            <el-input-number v-model="earlyDay" :step="1" :min="0" style="width: 100%"></el-input-number>
          </div>
          <div style="width:30%;margin-left:1%">
            <p style="margin-top:6px;margin-bottom:6px">最少提前预约天数</p>
            <el-input-number v-model="minEarlyDay" :step="1" :min="0" style="width: 100%"></el-input-number>
          </div>
        </div>
        <div style="display:flex;margin-top:10px;padding-left:20px">
          <div style="width:30%">
            <p style="margin-top: 6px;margin-bottom: 6px">每人每天允许预约几个时间段</p>
            <el-input-number v-model="roomMaxTimes" :step="1" style="width:100%"></el-input-number>
          </div>
          <div style="width:30%;margin-left:1%">
            <p style="margin-top: 6px;margin-bottom: 6px">同一时间段同一人允许预约次数</p>
            <el-input-number v-model="userMaxTimes" :step="1" style="width: 100%"></el-input-number>
          </div>
          <div style="width:30%;margin-left:1%">
            <p style="margin-top: 6px;margin-bottom: 6px">同一时间段允许预约人数</p>
            <el-input-number v-model="maxTimes" :step="1" style="width: 100%"></el-input-number>
          </div>
        </div>
        <div style="display:flex ; margin-top: 10px;padding-left:20px">
          <div style="width:30%">
            <p style="margin-top: 6px;margin-bottom: 6px">房间排序</p>
            <el-input-number v-model="sort" :step="1" style="width: 100%"></el-input-number>
          </div>
        </div>
        <div style="margin-top:10px;padding-left:20px;margin-bottom:10px">
          <p style="margin-top: 6px;margin-bottom: 6px">温馨提示</p>
          <textarea v-model="tipInfo" style="width:61%;height:10vh"></textarea>
        </div>
        <el-divider></el-divider>
        <div style="display:flex;align-items:center;margin:10px 20px">
          <p style="font-size:18px;font-weight:bold;margin:0">空间预约商品</p>
          <el-switch style="margin-left:10px"
                     v-model="needMoney">
          </el-switch>
          <p style="margin-top:0;margin-bottom:0;margin-left:10px;">空间预约是否付费</p>
          <el-button @click="onTc" type="primary" size="mini" style="margin-left: auto;margin-right: 10px">选择商品
          </el-button>
        </div>
        <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  show-overflow-tooltip :row-key="rowKey"
                  @selection-change="rowCurrentChange" ref="refShopsTab"
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column
              v-if="isShow"
              type="selection"
              fixed="left"
              :reserve-selection="true"
              :selectable="checkSelectable"
              width="60">
          </el-table-column>
          <el-table-column width="1px">
          </el-table-column>
          <div v-for="(d,item) in this.defHead">
            <el-table-column v-if="d.key==='商品图片'" :key=item :prop=d.val :label=d.key :width="d.w" align="center">
              <template slot-scope="scope">
                <div style="display: flex;align-items:center;justify-content: center;">
                  <el-image :src="scope.row.imgUrl" style="max-width:107px;height:60px">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <!--                  <p style="margin-left:15px">{{ scope.row.name }}</p>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else :key=item :prop=d.val :label=d.key :width="d.w">
            </el-table-column>
          </div>
          <el-table-column
              label="操作"
              width="200">
            <template slot-scope="scope">
              <el-button @click="onTmpDel()" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
        <div style="display:flex;width:100%;margin-top:10px;padding-bottom:30px">
          <el-button style="margin-left:auto;margin-right:1px;height:40px" type="info"
                     @click="onBack">取消
          </el-button>
          <el-button type="primary" @click="onKeep()" style="height:40px;margin-right:10px">保存
          </el-button>
        </div>
      </el-main>
    </el-container>
    <el-dialog title='添加商品' center :close-on-click-modal="false"
               width="60vw" height="600px" class="dialog_daiAddShops"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAddShops'> <!--v-draggable 拖动-->
      <div style="display:flex;height:50px;width:100%;line-height:0.3;text-align:left;align-items: center;">
        <p style="width:auto;margin-left:15px;font-size:16px;font-weight:bold">商品分类：</p>
        <el-select v-model="edi_type" ref='select5' clearable
                   placeholder="商品类型" @change="onUpData"
                   style="width:8vw;margin-left:1px">
          <el-option
              v-for="item in liType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="scan_name" @change="onUpData" clearable prefix-icon="el-icon-search"
                  placeholder="请输入商品名称" style="width:12vw;margin-left:10px"></el-input>
      </div>
      <div style="margin-top:1px;">
        <el-table :data=fil_tabShop class="myTable_db" :cell-style="tableYs" border
                  style="width:100%; font-size:14px; background:#ffffff;"
                  height="40vh" show-overflow-tooltip :row-key="rowKey"
                  @selection-change="handleCurrentChange1" ref="multipleTable"
                  @row-click="handleRowClick"
                  :header-cell-style="{'text-align':'center','background':'#F4F4F4','color':'#000000'}">
          <!--          <el-table-column-->
          <!--              type="selection"-->
          <!--              :reserve-selection="true"-->
          <!--              :selectable="selectable"-->
          <!--              width="60">-->
          <!--          </el-table-column>-->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked"
                           @change="(val) => handleCheckboxChange(val, scope.row)">
              </el-checkbox>
            </template>
          </el-table-column>
          <div v-for="(d,item) in this.liDevHead">
            <el-table-column v-if="d.key==='商品名称'" :key=item :prop=d.val :label=d.key :width="d.w">
              <template slot-scope="scope">
                <div style="display: flex;align-items:center">
                  <el-image :src="scope.row.imgUrl" style="max-width:107px;height:60px">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <p style="margin-left:15px">{{ scope.row.name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else :key=item :prop=d.val :label=d.key :width="d.w">
            </el-table-column>
          </div>
        </el-table>
        <div style="display: flex;width:100%">
          <el-pagination
              style="margin-left:auto;margin-right:10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10,20,30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="fil_total">
          </el-pagination>
        </div>
      </div>
      <div style="margin-top:10px;display:flex;height:50px;width:100%;line-height:0.3;
                  text-align:left;align-items:center;">
        <el-button @click="dialog_Onclick('退出')" style="margin-left: auto">取消</el-button>
        <el-button @click="dialog_Onclick('保存')" type="primary">保存</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import axios from 'axios';

export default {
  name:"resvSetSon",
  data() {
    return {
      h_text:"修改预约设置",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""},
        {"text":"预约设置","colour":"#B7B7B7","pages":""}
      ],
      scan_name:"",
      edi_type:"",
      liType:[],
      initShopId:"",
      selectedId:"",
      selectedRow:{},
      id:0,
      name:"房间",
      isShow:false,
      needMoney:false,
      isAppointing:false,
      onlyOwer:false,
      needApproval:false, /*是否需要审批*/
      isCare:false, /*是否需要填写人文关怀*/
      needService:false, /*是否需要填写服务*/
      isAttendNum:false, /*是否需要填写参与人数*/
      sort:1,/*房间排序*/
      maxAttendNum:10,/*预约最多填写人数*/
      earlyTime:0, /*提前开门时间*/
      earlyDay:0, /*提前预约*/
      minEarlyDay:0, /*最少提前多少天预约*/
      timeGap:0, /*时间段*/
      maxNum:0, /*最大人数*/
      cleanTime:0, /*清洁间隔*/
      maxTimes:0, /*同一时间段最多允许预约次数*/
      roomMaxTimes:0, /*每人天预约最多时间段*/
      userMaxTimes:0, /*同一时间段同一人预约次数*/
      tipInfo:"", /*提示*/
      daiAddShops:false,
      page:1,
      pageSize:10,
      total:0,
      pageType:1,
      pageSizeType:30,
      totalType:30,
      pwr:true,
      isCtr:true,
      startTime:"00:00",
      endTime:"23:59",
      d_info:{},
      liGoods:[],
      li_goods:[],
      liShop:[],
      li_shop:[],
      defHead:[
        {'key':"商品图片",'val':"imgUrl","w":"auto"},
        {'key':"商品名称",'val':"name","w":"auto"},
        {'key':"商品分类",'val':"goodsType","w":"auto"},
        {'key':"价格",'val':"skuPrice","w":"auto"},
        {'key':"总库存",'val':"kuCun","w":"auto"}
      ],
      liDevHead:[
        {'key':"商品名称",'val':"name","w":"auto"},
        {'key':"商品分类",'val':"goodsType","w":"auto"},
        {'key':"价格",'val':"skuPrice","w":"auto"},
        {'key':"总库存",'val':"kuCun","w":"auto"}
      ]
    };
  },
  methods:{ /*方法存放*/
    onUpData() {
      this.page = 1;
      this.getGoodsList();
    },
    onTmpDel() {
      this.selectedId = "";
      this.liGoods = [];
    },
    onDel(isTs) {
      const params = {
        roomId:this.id,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.cancelRoomAppointGoods,params,headers).then(res => {
        console.log("cancelRoomAppointGoods",res.data.data);
        if (isTs) {
          this.$message.success("移除成功");
        }
        this.liGoods = [];
        this.changeNotice();
      }).catch(error => {
        console.log(error);
        if (isTs) {
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("移除商品失败");
          }
        }
      });
    },
    onTc() {
      this.getGoodsTypeList();
      this.edi_type = '';
      this.scan_name = '';
      this.getGoodsList();
      this.daiAddShops = true;
    },
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    selectable(row,index) { /*表格勾选框判断*/
      console.log(row);
      let is_show = true;
      // if(row.isBleDev !== false) {
      //   is_show = false;
      // } else if(row.did === "dmy_air_lan_zjl_100") {
      //   is_show = false;
      // }
      return is_show;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGoodsList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getGoodsList();
    },
    handleCheckboxChange(checked,row) {
      // 如果已经有选中的行，则清除之前的选中状态，并设置新的选中行
      if (checked) {
        // 1. 清空所有行的复选框选中状态
        this.liShop.forEach(item => {
          item.checked = false;
        });
        // 2. 选中当前行的复选框
        row.checked = true;
        // 3. 更新选中状态
        this.selectedId = row.id;
        this.selectedRow = row;
      } else {
        // 取消选中时重置状态
        this.selectedId = null;
        this.selectedRow = null;
      }
    },
    handleCurrentChange1(val) { /*获取所有选中行*/
      this.currentRow = val;
      console.log(this.currentRow);
    },
    handleRowClick(row,event,column) {
      this.currentRow = row; // 更新当前选中行
    },
    dialog_Onclick(v) {
      switch (v) {
        case "保存":
          if (!this.selectedId) {
            this.$message.warning('请先勾选一个商品');
            return;
          }
          this.daiAddShops = false;
          this.getGoodsId(this.selectedId);
          break;
        case "退出":
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = '#283A4D';
          },300);
          this.daiAddShops = false; /*将dialog关闭*/
          break;
      }
    },
    keepSp() {
      if (this.initShopId && !this.selectedId) { /*已有删除*/
        this.onDel(false);
      } else if (this.selectedId) { /*替换-没有新增*/
        const params = {
          roomId:this.id,
          goodsId:this.selectedId,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.setRoomAppointGoods,params,headers).then(res => {
          console.log("setRoomAppointGoods",res.data.data);
          // this.$message.success("添加成功");
          this.changeNotice();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("保存失败");
          }
        });
      }
    },
    onKeep() {
      if (!(this.startTime || this.endTime)) {
        this.$message.info('请先选择起始/结束时间');
        return;
      }
      if (this.isCtr) {
        this.isCtr = false;
        if (this.initShopId !== this.selectedId) {
          this.keepSp();
        } else {
          this.changeNotice();
        }
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    rowKey(row) { /*返回对应唯一值防止选中乱跳*/
      return row.id;
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    checkSelectable(row,index) { /*tab选择框禁用*/
      return true;
    },
    rowCurrentChange(val) { /*获取所有选中行*/
      this.liRow = val;
      if (this.liShop && this.liRow.length === this.liShop.length) {
        this.edi_check = true;
      } else {
        this.edi_check = false;
      }
      console.log(this.liRow);
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true; // 如果校验通过，返回true继续上传流程
    },
    uploadFile(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId = response.data.data.id;
            this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess1(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    beforeAvatarUpload1(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true; // 如果校验通过，返回true继续上传流程
    },
    uploadFile1(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId1 = response.data.data.id;
            this.imageUrl1 = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    changeNotice() {
      const params = {
        id:this.id,
        name:this.name,
        isAppointing:this.isAppointing,
        onlyOwer:this.onlyOwer,
        needApproval:this.needApproval,
        isCare:this.isCare,
        isAttendNum:this.isAttendNum,
        needService:this.needService,
        needMoney:this.needMoney, /*空间预约付费*/
        openStartTime:this.parseToInt(this.startTime), /*预约起始时间*/
        openEndTime:this.parseToInt(this.endTime),
        earlyTime:parseInt(this.earlyTime), /*提前开门时间*/
        earlyDay:parseInt(this.earlyDay), /*提前预约*/
        minEarlyDay:parseInt(this.minEarlyDay), /*提前预约天数*/
        timeGap:parseInt(this.timeGap), /*时间段*/
        maxNum:parseInt(this.maxNum), /*最大人数*/
        cleanTime:parseInt(this.cleanTime), /*清洁间隔*/
        maxTimes:parseInt(this.maxTimes), /*最大预约场次*/
        roomMaxTimes:parseInt(this.roomMaxTimes), /*每人每天允许时间段*/
        userMaxTimes:parseInt(this.userMaxTimes), /*同一时间段允许次数*/
        maxAttendNum:parseInt(this.maxAttendNum), /*预约最多填写人数*/
        sort:parseInt(this.sort), /*房间排序*/
        tipInfo:this.tipInfo, /*提示*/
        pubTime:parseInt("" + new Date().getTime() / 1000),
        sysUserId:localStorage.getItem("userId"),
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateRoomAppointInfo,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      if (this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    parseToInt(li_str) { /*字符串转分钟*/
      if (li_str) {
        const arr = li_str.split(":");
        if (arr.length === 2) {
          const h = parseInt(arr[0]);
          const m = parseInt(arr[1]);
          return h * 60 + m;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    parseToTime(val) { /*数字转时间*/
      if (val) {
        let h = `${parseInt(val / 60)}`.toString().padStart(2,'0') + ":";
        let m = `${parseInt(val % 60)}`.toString().padStart(2,'0');
        return h + m;
      } else {
        return "00:00";
      }
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    initShop() {
      let li_d = [];
      for (let i = 0; i < this.li_shop.length; i++) {
        let d = {
          id:this.li_shop[i]['id'],
          name:this.li_shop[i]['name'],
          imgUrl:"",
          room:this.li_shop[i]['room'],
          goodsType:this.li_shop[i]['goodsType']['name'],
          goodsState:this.li_shop[i]['goodsState']['name'],
          checked:false,
          kuCun:0,
          saled:0,
          skuPrice:0
        };
        if (this.li_shop[i]['roomId']) {
          continue;
        }
        if (this.li_shop[i]['iconBig']) {
          d['imgUrl'] = this.$urls.ip + "/" + this.li_shop[i]['iconBig']['url'];
        }
        if (this.li_shop[i]['goodsSku'] && this.li_shop[i]['goodsSku'].length > 0) {
          d["kuCun"] = this.li_shop[i]['goodsSku'][0]['kuCun'];
          d["saled"] = this.li_shop[i]['goodsSku'][0]['saled'];
          if (this.li_shop[i]['goodsSku'][0]['skuPrice'].length > 0) {
            d["skuPrice"] = this.li_shop[i]['goodsSku'][0]['skuPrice'][0]['price'] / 100;
          }
        }
        li_d.push(d);
      }
      console.log("-----",li_d);
      this.liShop = li_d;
    },
    getGoodsTypeList() {
      if (this.pageType < this.totalType / this.pageSizeType + 1) {
        const params = {
          page:this.pageType,
          pageSize:this.pageSizeType,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.getGoodsTypeList,params,headers).then(res => {
          console.log("getGoodsTypeList",res.data.data);
          this.totalType = res.data.data.total;
          if (res.data.data.list) {
            const l_d = this.liType;
            let l = res.data.data.list;
            for (let i = 0; i < l.length; i++) {
              l_d.push({label:l[i]['name'],value:l[i]['id']});
            }
            this.liType = l_d;
            this.pageType += 1;
            this.getGoodsTypeList();
          }
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("获取商品类型数据失败");
          }
        });
      }
    },
    getGoodsList() {
      const params = {
        page:this.page,
        pageSize:this.pageSize,
        goodsTypeId:2, //1-普通商品,2-预约商品
        goodsstateId:1,
        projectId:localStorage.getItem("projectId")
      };
      if (this.edi_type) {
        params['goodsTypeId'] = this.edi_type;
      }
      if (this.scan_name.length > 0) {
        params['name'] = this.scan_name;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoodsList,params,headers).then(res => {
        console.log("getGoodsList",res.data.data);
        this.total = res.data.data.total;
        if (res.data.data.list) {
          this.li_shop = res.data.data.list;
          this.initShop();
        } else {
          this.liShop = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品数据失败");
        }
      });
    },
    getRoom() {
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getRoomInfo,params,headers).then(res => {
        console.log("getRoomInfo：",res.data.data);
        this.d_info = res.data.data;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    init_View() {
      let d = this.d_info;
      this.name = d.name;
      this.isAppointing = d.isAppointing;
      this.onlyOwer = d.onlyOwer;
      this.needApproval = d.needApproval;
      this.isCare = d.isCare;
      this.isAttendNum = d.isAttendNum;
      this.needMoney = d.needMoney; /*空间预约付费*/
      this.needService = d.needService;
      this.startTime = this.parseToTime(d['openStartTime']);
      this.endTime = this.parseToTime(d['openEndTime']);
      this.earlyTime = d.earlyTime; /*提前开门时间*/
      this.earlyDay = d.earlyDay; /*提前预约*/
      this.minEarlyDay = d.minEarlyDay; /*最少提前多少天预约*/
      this.timeGap = d.timeGap; /*时间段*/
      this.maxNum = d.maxNum; /*最大人数*/
      this.cleanTime = d.cleanTime; /*清洁间隔*/
      this.maxTimes = d.maxTimes; /*同一时间段最多允许预约次数*/
      this.roomMaxTimes = d.roomMaxTimes; /*每人天预约最多时间段*/
      this.userMaxTimes = d.userMaxTimes; /*同一时间段同一人预约次数*/
      this.maxAttendNum = d.maxAttendNum; /*预约最多填写人数*/
      this.sort = d.sort; /*房间排序*/
      this.tipInfo = d.tipInfo; /*提示*/
      if (d.appointGoodsId) {
        this.initShopId = d.appointGoodsId;
        this.selectedId = d.appointGoodsId;
        this.getGoodsId(d.appointGoodsId);
      }
    },
    getGoodsId(appointGoodsId) {
      const params = {
        page:this.page,
        pageSize:this.pageSize,
        id:appointGoodsId,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoodsList,params,headers).then(res => {
        console.log("getGoodsList",res.data.data);
        if (res.data.data.list) {
          this.li_goods = res.data.data.list;
          this.initGoods();
        } else {
          this.li_goods = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品数据失败");
        }
      });
    },
    initGoods() {
      let li_d = [];
      for (let i = 0; i < this.li_goods.length; i++) {
        let d = {
          id:this.li_goods[i]['id'],
          name:this.li_goods[i]['name'],
          imgUrl:"",
          //room:this.li_shop[i]['room'],
          goodsType:'',
          goodsState:'',
          kuCun:0,
          saled:0,
          skuPrice:0
        };
        if (this.li_goods[i]['iconBig']) {
          d['imgUrl'] = this.$urls.ip + "/" + this.li_goods[i]['iconBig']['url'];
        }
        if (this.li_goods[i]['goodsType']) {
          d['goodsType'] = this.li_goods[i]['goodsType']['name'];
        }
        if (this.li_goods[i]['goodsState']) {
          d['goodsState'] = this.li_goods[i]['goodsState']['name'];
        }
        if (this.li_goods[i]['goodsSku'] && this.li_goods[i]['goodsSku'].length > 0) {
          d["kuCun"] = this.li_goods[i]['goodsSku'][0]['kuCun'];
          d["saled"] = this.li_goods[i]['goodsSku'][0]['saled'];
          if (this.li_goods[i]['goodsSku'][0]['skuPrice'] && this.li_goods[i]['goodsSku'][0]['skuPrice'].length > 0) {
            d["skuPrice"] = this.li_goods[i]['goodsSku'][0]['skuPrice'][0]['price'] / 100;
          }
        }
        li_d.push(d);
      }
      this.liGoods = li_d;
    }
  },
  mounted() { /*页面加载时调用*/
    this.id = parseInt(this.$route.query.id);
    this.getRoom();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.liGoods.filter(item => {
        this.state = true;
        return this.state;
      });
    },
    fil_tabShop() {
      return this.liShop.filter(item => {
        this.state = true;
        return this.state;
      });
    },
    fil_total() {
      return this.fil_tabShop.length;
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#resvSetSon {
  height: 100vh;
  margin: 0;
  overflow-y: auto;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  padding-bottom: 80px;
  background: #F4F4F4;
}

.resv_main {
  background: #F4F4F4;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/resvSetSon.vue